import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "historystateinfo"
    }}>{`HistoryStateInfo`}</h1>
    <p>{`Options for the history state that `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#suspendhistory"
      }}>{`Document.suspendHistory`}</a>{` will create`}</p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "name"
    }}>{`name`}</h3>
    <p>{`• `}<strong parentName="p">{`name`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <p>{`Name of the history state to be shown in History panel`}</p>
    <hr></hr>
    <h3 {...{
      "id": "target"
    }}>{`target`}</h3>
    <p>{`• `}<strong parentName="p">{`target`}</strong>{`: `}{`[{ `}<inlineCode parentName="p">{`_id`}</inlineCode>{`: `}<em parentName="p">{`number`}</em>{` ; `}<inlineCode parentName="p">{`_ref`}</inlineCode>{`: `}<inlineCode parentName="p">{`"document"`}</inlineCode>{`  }]`}</p>
    <p>{`A single document reference in an array with `}<inlineCode parentName="p">{`_id`}</inlineCode>{` of the document whose history will be suspended`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      